import React from 'react';
import { useForgotPasswordHook } from './useForgotPasswordHook';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, CheckCircle } from 'lucide-react';
import { Input } from '@/shared/components/atoms/Input';
import { Button } from '@/shared/components/atoms/Button';
import { AuthLayout } from '../../components/AuthLayout';
import '../Login/Login.css';

const ForgotPasswordLeftContent = () => (
  <>
    <p className="login-tagline">
      Don't worry, we'll get you back on track in no time.
    </p>

    <div className="login-features">
      <div className="login-feature-item">
        <span className="login-feature-bullet" />
        <p className="login-feature-text">
          <strong>Secure Reset:</strong> Receive a one-time link to securely reset your password.
        </p>
      </div>
      <div className="login-feature-item">
        <span className="login-feature-bullet" />
        <p className="login-feature-text">
          <strong>Instant Access:</strong> Change your password and get back to your sales workflows immediately.
        </p>
      </div>
    </div>
  </>
);

const ForgotPassword = () => {
  const { email, setEmail, isLoading, isSuccess, handleSubmit } = useForgotPasswordHook();

  return (
    <AuthLayout leftContent={<ForgotPasswordLeftContent />}>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
      >
        <h2 className="auth-heading">Forgot Password</h2>
        <p className="auth-subheading">Enter your email to receive a reset link.</p>

        {!isSuccess ? (
          <form onSubmit={handleSubmit} noValidate>
            <div className="auth-input-group" style={{ marginBottom: '12px' }}>
              <Input
                label="Email Address"
                leftIcon={<Mail size={13} />}
                type="email"
                name="email"
                id="forgot-email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </div>

            <Button type="submit" variant="secondary" fullWidth isLoading={isLoading} style={{ marginTop: '8px' }}>
              Send Reset Link
            </Button>
          </form>
        ) : (
          <div className="text-center space-y-6 flex flex-col items-center" style={{ marginTop: '20px', marginBottom: '20px' }}>
            <div className="w-16 h-16 bg-green-500/10 text-green-400 rounded-full flex items-center justify-center mb-4 border border-green-500/20">
              <CheckCircle size={32} />
            </div>
            <p className="text-gray-300">
              We've sent a password reset link to <strong className="text-white">{email}</strong>. Please check your inbox.
            </p>
          </div>
        )}

        <p className="auth-switch-link-text">
          Remember your password?{' '}
          <Link to="/login" className="auth-switch-link">
            Sign In
          </Link>
        </p>
      </motion.div>
    </AuthLayout>
  );
};

export default ForgotPassword;
